module.exports = __webpack_public_path__ + "static/media/x.ee76947f.svg";